import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../config";
import tokenService from "./sso/token.service";
import { OauthModel } from "./sso/oauth.model";
import storage from "./sso/storage";



const instanceGPTUpload = axios.create({
  baseURL: config.chat_gpt.base_url,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

const instanceRefresh = axios.create({
  baseURL: config.authen.api.host_url,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

instanceGPTUpload.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem(storage.user)!) as OauthModel;
    if (user.access_token) {
      // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      config.headers["scoutout-authorization"] = user.access_token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    alert(error);
    window.open('/')
    return Promise.reject(error);
  }
);

instanceGPTUpload.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
  
    
    const originalConfig = err.config;
    if (originalConfig.url !== config.authen.api.token && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instanceRefresh.post(config.authen.api.token, {
            grant_type: 'refresh_token',
            refresh_token: tokenService.getLocalRefreshToken(),
          });
          if(rs.data){
            const token = rs.data as OauthModel
            localStorage.setItem(storage.user, JSON.stringify(token))
          }else if(rs.status == 404){
            window.open("/login");
          }
          return instanceGPTUpload(originalConfig);
        } catch (_error) {
        
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instanceGPTUpload;